export default __webpack_public_path__ + "locales/pt-BR/Common.json?hash=45469379a07210dd8bceb2ac65bbbd43";